import { ref } from 'vue'
import { fetchUnreadCount } from '../services/supportService'
import { getValidToken, getCurrentUser } from '../services/authService'

// Синглтон — module-level state (аналог useAlarmState.js)
// Кількість непрочитаних повідомлень підтримки для бейджа на пункті «Заявки»
const unreadCount = ref(0)

let pollTimer = null
// Мітка останнього запиту — коалесуємо залп poke-подій (кілька відповідей поспіль)
let lastFetchTs = 0
const MIN_GAP_MS = 2000
// Фоновий поллінг рідкий: основний канал доставки — WS-poke через user:{owner}
const POLL_INTERVAL_MS = 60000

async function refresh(force = false) {
  if (!getValidToken()) {
    unreadCount.value = 0
    return
  }
  // Суб-користувачам «Заявки» не показуються (App.vue ховає пункт меню)
  const u = getCurrentUser()
  if (u?.isSubUser) {
    unreadCount.value = 0
    return
  }
  const now = Date.now()
  if (!force && now - lastFetchTs < MIN_GAP_MS) return
  lastFetchTs = now
  try {
    const data = await fetchUnreadCount()
    unreadCount.value = Number(data?.unread) || 0
  } catch {
    // Мережева помилка — лишаємо попереднє значення, наступний тик поправить
  }
}

// WS-poke з каналу user:{owner} (диспатчиться в useAlarmState при type=support_message)
function onPoke() {
  refresh(true)
}

// Повернення на вкладку — бейдж міг застаріти, поки таймери були затротлені
function onVisible() {
  if (!document.hidden) refresh()
}

function startSupportUnread() {
  if (pollTimer) return
  refresh(true)
  pollTimer = setInterval(refresh, POLL_INTERVAL_MS)
  window.addEventListener('support-unread-poke', onPoke)
  document.addEventListener('visibilitychange', onVisible)
}

function stopSupportUnread() {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
  window.removeEventListener('support-unread-poke', onPoke)
  document.removeEventListener('visibilitychange', onVisible)
}

/**
 * Composable бейджа непрочитаних повідомлень підтримки.
 * Запускається глобально з App.vue; оновлення: WS-poke + рідкий поллінг (60с).
 * Після прочитання чату сторінки викликають refresh(true) для миттєвого скидання.
 */
export function useSupportUnread() {
  return {
    unreadCount,
    refresh,
    start: startSupportUnread,
    stop: stopSupportUnread,
  }
}
